// Shop Surfsight Domain Configuration
export const shopsurfsightConfig = {
  // Basic domain information
  id: 'shopsurfsight',
  name: 'Shop Surfsight',
  tagline: 'Professional Fleet Camera Equipment & Accessories',
  description: 'Complete fleet camera equipment and accessories shop with professional solutions.',
  
  // Assets
  logo: '/assets/logos/shopsurfsight-logo.png',
  whiteLogo: '/assets/logos/shopsurfsight-white-logo.png',
  favicon: '/assets/favicons/shopsurfsight-favicon.png',
  icon: '/assets/icons/shopsurfsight',
  
  // Navigation
  pages: ['home', 'solutions', 'products', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Products', path: '/products' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
                
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/surfsight-lytx',

  // UI Configuration
  variant: 'elegant',
  showFeatures: false,
  showTestimonials: false,
  
  // Content sections
  hero: {
    title: 'Shop Surfsight',
    subtitle: 'Complete fleet camera equipment and accessories shop with professional solutions for all your fleet camera needs.',
    features: ['Professional equipment', 'Expert consultation', 'Fast shipping', 'Warranty support']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Shop Surfsight Gallery',
    subtitle: 'Explore our professional fleet camera equipment and accessories',
    description: 'See our comprehensive range of Surfsight camera solutions and professional equipment'
  },

  features: {
    title: 'Shop Surfsight Features',
    subtitle: 'Professional Fleet Camera Equipment',
    description: 'Enterprise-level cameras and accessories with comprehensive solutions for all your fleet camera needs.',
    items: [
      {
        title: 'Wide Product Range',
        description: 'Extensive selection of fleet camera equipment, accessories, and technology solutions.',
        icon: '🛍️'
      },
      {
        title: 'Expert Consultation',
        description: 'Professional consultation services to help you choose the right camera equipment for your fleet.',
        icon: '👨‍💼'
      },
      {
        title: 'Fast Shipping',
        description: 'Quick and reliable shipping with tracking and insurance for all orders.',
        icon: '🚚'
      },
      {
        title: 'Warranty Support',
        description: 'Comprehensive warranty coverage with dedicated support and service teams.',
        icon: '🛡️'
      },
      {
        title: 'Professional Installation',
        description: 'Expert installation services to ensure your camera equipment is properly set up.',
        icon: '🔧'
      },
      {
        title: 'Technical Support',
        description: 'Dedicated technical support team to help with any camera equipment issues.',
        icon: '📞'
      }
    ]
  },
  
  solutions: {
    title: 'Surfsight Fleet Camera Solution',
    subtitle: 'Professional camera equipment for your fleet',
    description: 'Discover our comprehensive range of fleet camera solution designed to enhance safety and optimize your operations by Lytx.',
    sections: [
      {
        title: 'Professional Fleet Camera Equipment',
        description: 'Complete range of professional fleet camera equipment including dash cameras, AI-powered cameras, and monitoring systems designed for fleet safety and compliance.',
      },
      {
        title: 'Fleet Camera Accessories',
        description: 'Comprehensive selection of camera accessories including mounts, cables, storage solutions, and monitoring equipment to enhance your fleet camera systems.',
      },
      {
        title: 'Installation & Support Services',
        description: 'Professional installation services and ongoing technical support to ensure your fleet camera equipment operates at peak performance.',
      }
    ]
  },

  testimonials: [
    {
      content: "Surfsight has been our go-to source for fleet camera equipment. The quality and service are outstanding.",
      author: "John Thomas",
      role: "Fleet Manager",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      content: "The professional installation service and ongoing support have made all the difference in our fleet camera operations.",
      author: "Timothy Soh",
      role: "Operations Director",
      company: "",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg"
    }
  ],

  products: {
    title: 'Shop Surfsight Products',
    subtitle: 'Professional fleet camera equipment and accessories for all your fleet safety needs.',
    categories: [
      { id: 'all', name: 'All Products' },
      { id: 'cameras', name: 'Cameras' },
      { id: 'aux', name: 'Auxiliary' },
      { id: 'harnesses', name: 'Harnesses' },
      { id: 'monitor', name: 'Monitors' },
    ],
    items: [
      {
        id: 7,
        title: 'Surfsight AI-12 DCC07-12',
        description: 'The DCC07-12 brings you the most advanced reporting features currently available in the video dash camera market.',
        brand: 'Surfsight',
        category: 'cameras',
        productLink: 'https://shop.fleethoster.com/products/dcc07-12',
        image: 'product-7',
        featured: true,
        details: [
          {
            title: 'Introducing',
            description: 'Now with DCC07-12 you can set up rules inside of your database that manage events and video for you! Maybe you don’t want videos downloaded anytime a vehicle goes 10mph over the posted speed limit. Set a rule to note it but not download the video. Furthermore, you can create a rule for detected collision to automatically record 10 seconds before and after the event and automatically download videos you want. It’s all about efficiency for your staff and data (both can be costly). You want live video to protect your company accurately and efficiently—this DCC07-12 kit gives exactly that!',
            features: []
          },
          {
            title: 'What makes this system special?',
            description: '',
            features: [
              'Live streaming',
              'IR night-vision',
              'Distracted driver detection',
              'Wi-Fi hotspot connectivity for up to 4 additional wireless cameras',
              'Driver coaching feature',
              'A.I.-ready',
              'Panic button',
              'Tamper detection', 
              'Built-in storage and cloud storage',
              'Parking mode',
              'SIM and SD card lock',
              'Over-the-air upgrades',
              '10-minute installation',
              'Integrated into Geotab'
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'Adjustable event/trigger setting levels to get videos when you want them',
              'Parking mode allows you to record an event even with ignition off',
              'Automatic server upload based on events prevents driver tampering of SD card',
              'Can be used as both GPS telematics device & dashcam in one sleek device',
              'Integrated into Geotab so any vehicle rule can trigger a video event from camera'
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Live stream, Dual IR, Distracted Driver detect, WiFi hotspot connectivity for more cameras',
              'Forward & Rear facing dual cam w/ IR + Optional cameras for WiFi expandability',
              'Live Stream, Event-based, 30-day backup',
              'Input Voltage - 5V 2amp',
              'Operating Temperature - -10°C to +85°C (14°F to +185°F)',
              'Hardwire or OBD2 plug & play',
              'HD 1080p road facing',
              '720p driver facing',
            ]
          }
        ]
      },
      {
        id: 22,
        title: 'DCA01-SC Auxiliary Side Camera',
        description: 'An auxiliary side camera designed to enhance fleet security and visibility with HD resolution and night vision capabilities.',
        brand: 'Surfsight',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-sc',
        image: 'product-22',
        featured: true,
        details: [
          {
            title: 'Product Description',
            description: 'The DCA01-SC is an auxiliary side camera designed to enhance fleet security and visibility. This camera is ideal for capturing side views of vehicles, improving situational awareness and safety during fleet operations.',
            features: [
              '1080p HD resolution',
              'Night vision capabilities',
              'Rugged design',
              'Compatibility with FleetFlix AI+ and SurfSight AI-12 systems'
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'IP66-rated durability for outdoor use',
              'Expandable coverage with support for up to 4 auxiliary cameras',
              'Optional magnetic mounts for easy installation',
              'Customizable event triggers for specific scenarios',
              'Automated event uploads to a server',
              'Seamless integration into Geotab'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Tech Available: Live stream, Dual IR, 1080p, Nighttime view',
              'Video Availability: Live stream, Event-based',
              'Input Voltage: 12V, 2 amp',
              'Operating Temperature: −10°C to +85°C',
              'Installation Methods: Hardwire powered',
              'Video: Road capture in HD 1080p',
              'IP Rating: IP66 (dust-tight and protected against powerful water jets)'
            ]
          }
        ]
      },
      {
        id: 9,
        title: 'DCA01-FFLITE-RC-AHD Aux Cam',
        description: 'FleetFlix Lite auxiliary cameras that connect to FleetFlix Lite and FleetFlix Lite Pro+ dashcams, providing 360° video coverage with HD recording from multiple vehicle perspectives.',
        brand: 'Surfsight',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-fflite-rc-ahd',
        image: 'product-9',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'FleetFlix Lite auxiliary cameras are connected to FleetFlix Lite and FleetFlix Lite Pro+ dashcams. When connected to the dash camera, the cameras enable live video and recording from additional perspectives during trips. The cameras are installed around the vehicle in key locations (side and rear). All auxiliary cameras include a high-definition 1920×1080 lens, auto gain, 3D noise reduction, and backlight compensation. They provide 360° video coverage for the fleet.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Image sensor: 1/2.8" 2.13M pixel CMOS',
              'Resolution: 1920H × 1080V',
              'Minimum illumination: 0LUX (IR on); 0.05LUX (IR off)',
              'Auto electronic shutter, auto exposure, and auto white balance',
              'IR range: 10M (12 Q5 850NM LED dots)',
              'IP rating: IP67',
              'Includes a 0.5M waterproof aviation cable, DC12V black shell',
              'White balance auto tracking'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Signal-to-noise ratio: ≥50dB',
              'Electronic shutter speed: 1/25s ~ 1/25,000s (auto)',
              'Day/night mode: ICR IR filter',
              'Operating temperature: -40°C to +70°C',
              'Operating humidity: <95% (no condensation)',
              'Power supply: DC12V ±10%',
              'Dimensions: 3 in × 2.5 in × 2.9 in (75mm × 65.1mm × 73.7mm)',
              'Weight: 0.6 lbs (280g)',
              'Power consumption: ~130mA / DC12V ±5%'
            ]
          },
          {
            title: 'Lens Options',
            description: '',
            features: [
              '2.5mm M12@ F2.0; HFOV: 123°, VFOV: 69°, DFOV: 141°',
              '2.8mm M12@ F2.0; HFOV: 103°, VFOV: 56°, DFOV: 121°',
              '3.6mm M12@ F2.2; HFOV: 88°, VFOV: 49°, DFOV: 103°',
              'Other lens options with varying fields of view available',
              'Composite video output at various specifications'
            ]
          }
        ]
      },
      {
        id: 10,
        title: 'DCA01-FFLITE-SC-CA39-AHD Aux Cam',
        description: 'High-definition auxiliary camera compatible with FleetFlix Lite systems, offering 360° video coverage with advanced features like auto gain and 3D noise reduction.',
        brand: 'Surfsight',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-lite-sc-ahd',
        image: 'product-10',
        featured: false,
        details: [
          {
            title: 'Product Description', 
            description: 'FleetFLIX Lite auxiliary cameras are connected to FleetFLIX Lite and FleetFLIX Lite Pro+ dashcams. When connected to the dash camera, the cameras enable live video and recording from the portal of additional perspectives during trips. The cameras are installed around the vehicle in key locations (side and rear). All auxiliary cameras include a high-definition 1920×1080V lens. Auto gain, 3D noise reduction, and backlight compensation are all supported. Provide your fleet with 360° video coverage.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Image sensor: 1/2.8" 2.13M pixel CMOS',
              'Resolution: 1920H × 1080V',
              'Minimum illumination: 0LUX (IR on), 0.05LUX (IR off)', 
              'Auto electronic shutter, auto exposure, and auto white balance',
              'IR range: 10–15M',
              'IP rating: IP69K',
              'Compact design and simple installation',
              'Vehicle damping performance optimization'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Signal-to-noise ratio: ≥50dB',
              'Electronic shutter: 1/25s ~ 1/25,000s (auto)',
              'Day/night mode: ICR IR filter',
              'Operating temperature: -40°C to +70°C',
              'Operating humidity: <95% (no condensation)',
              'Power supply: DC12V ±10%',
              'Video output: 1.0VP-P composite, 75Ω, 4PIN aviation cable',
              'Power consumption: 260mA / DC12V ±5%',
              'Dimensions: 2.59 in × 2.29 in × 1.8 in (66mm × 58mm × 46mm)',
              'Weight: 0.39 lbs (180g)'
            ]
          },
          {
            title: 'Lens Options',
            description: '',
            features: [
              '2.2mm M12@ F2.0 (HFOV: 152°, VFOV: 83°, DFOV: 180°)',
              '2.8mm M12@ F2.0 (HFOV: 103°, VFOV: 56°, DFOV: 121°)',
              '3.6mm M12@ F2.2 (HFOV: 88°, VFOV: 49°, DFOV: 103°)'
            ]
          }
        ]
      },
      {
        id: 1,
        title: 'Geotab GO9 Device',
        description: 'Advanced telematics device with 4G connectivity, GPS tracking, and comprehensive vehicle diagnostics.',
        brand: 'Geotab',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/vtd12-go9',
        image: 'product-1',
        featured: false,
        details: [
          {
            title: 'Precise GPS tracking',
            description: 'Collect precise data on vehicle location, speed, trip distance and time, engine idling and more with the GO9. Even if you park a vehicle indoors and underground, advanced GPS vehicle tracking and telematics starts recording as soon as you begin driving. The GO9 introduces the new Global Navigation Satellite System module (GNSS) for faster latch times and increasingly accurate location data.',
            features: []
          },
          {
            title: 'Vehicle health assessments',
            description: 'Extract valuable vehicle health information within our fleet vehicle tracking system. Capture and record the vehicle identification number (VIN), odometer reading, engine faults and more. This data helps you prioritize vehicle fleet maintenance and audit vehicle use to identify both safe and risky driving behaviors.',
            features: []
          },
          {
            title: 'Collision detection and notification',
            description: 'GO9 offers harsh-event data (such as aggressive acceleration, harsh braking or cornering) and collision reconstruction through its accelerometer and our patented algorithms. If GO9 detects a suspected collision, it will automatically upload detailed data that enables forensic reconstruction of the event. This includes in-vehicle reverse collisions. Email and desktop alerts signal the first notice of loss.',
            features: []
          },
          {
            title: 'Secured data',
            description: 'Geotab uses authentication, encryption and message integrity verification for GO9 vehicle tracking devices and network interfaces. Each GO9 device uses a unique ID and non-static security key, making it difficult to fake a device’s identity. Over-the-air (OTA) updates use digitally signed firmware to verify that updates come from a trusted source.',
            features: []
          },
          {
            title: 'In-vehicle driver coaching',
            description: 'Improve driving behaviors, such as following speed limits and reducing idling time, by playing an audible alert. GO9 also enables you to coach the driver with spoken words (available as an Add-On). Immediate driver feedback can enhance fleet safety, reinforce company policy and encourage your drivers to take immediate corrective action.',
            features: []
          },
          {
            title: 'Advanced data capture',
            description: 'Vehicles send data from a multitude of sources, including the engine, drivetrain, instrument cluster and other subsystems. Utilizing multiple internal networks, the GO9 captures and organizes much of this data.',
            features: []
          }
        ]
      },
      {
        id: 23,
        title: '7-inch HD Fleet Monitor',
        description: 'High-definition 7-inch monitor designed for fleet vehicles, featuring dual-channel support, IPS display, and rugged construction for enhanced driver visibility and safety.',
        category: 'monitor',
        productLink: 'https://shop.fleethoster.com/products/acc01-lite-mon-7hd',
        image: 'product-23',
        featured: true,
        details: [
          {
            title: 'Product Description',
            description: 'The 7-inch high-definition monitor enhances the driver\'s ability to observe vehicle operations and the surrounding environment clearly, improving both safety and efficiency. With simple button operation, high resolution and brightness, high contrast, and wide viewing angle, this monitor is suitable for various driving scenarios, improving the driving experience and vehicle operating efficiency.',
            features: []
          },
          {
            title: 'Features',
            description: '',
            features: [
              'Dual-channel support with 2 video inputs and dual/single image segmentation display',
              'IPS screen with fast response speed, wide viewing angle, and true color (1024 RGB × 600 resolution)',
              'OSD menu for mirror/normal image settings, delay time configuration, and trigger priority management',
              'Rugged design with high-temperature resistant ABS + PC materials',
              'Removable sun hat to reduce glare from direct sunlight',
              'Rust-proof metal bracket with U-shaped double-sided fastening and anti-vibration design',
              'High brightness of 600 cd/㎡ for clear image visibility',
              'Load dump pulse voltage protection (DC 24V + 174V for 350 ms)',
              'Energy-efficient power supply with low-temperature stability',
              'Wide voltage range operation (DC 11–32V)',
              'Built-in reverse polarity protection with LED thermal response'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Screen Size: 7 inches (177 mm)',
              'Color System: AHD 720P / 1080P',
              'Display Resolution: 1024 RGB(H) × 600(V)',
              'Viewable Area: 154.4 mm × 85.9 mm',
              'Brightness: 600 cd/㎡',
              'Contrast Ratio: 700:1',
              'Viewing Angle: 160° / 160°',
              'LED Power: 8.7V / 220mA',
              'Maximum Power Consumption: 5W',
              'Operating Voltage: DC 11–32V',
              'Operating Temperature: −20°C to +70°C (−4°F to +158°F)',
              'Storage Temperature: −30°C to +80°C (−30°F to +176°F)',
              'Motherboard Chipset: ATM630M',
              'Power Output: DC 10.5V / 750mA',
              'Dimensions: 8.5 in × 5.9 in × 3.3 in (216 mm × 150 mm × 85 mm)',
              'Net Weight: 28.2 oz (800 g)'
            ]
          }
        ]
      },
      {
        id: 12,
        title: 'Harness 3WOBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-3wobdk',
        image: 'product-12',
        featured: false
      },
      // {
      //   id: 13,
      //   title: 'Harness 4W6POBDK',
      //   description: '',
      //   category: 'harnesses',
      //   productLink: 'https://shop.fleethoster.com/products/hrn01-4w6pobdk',
      //   image: 'product-13',
      //   featured: false
      // },
      {
        id: 14,
        title: 'Harness 4W9POBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-4w9pobdk',
        image: 'product-14',
        featured: false
      },
      {
        id: 15,
        title: 'Harness 4WOBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-4wobdk',
        image: 'product-15',
        featured: false
      },
    ],
  },

  blog: {
    title: 'Shop Surfsight Blog',
    subtitle: 'Latest News and Insights',
    description: 'Stay informed with the latest news and insights in fleet management and industry best practices.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Shop Surfsight - Fleet Camera Equipment & Accessories',
    description: 'Professional fleet camera equipment and accessories with wide selection, expert advice, fast shipping, and warranty support.',
    keywords: [
      'shop surfsight', 'fleet camera equipment', 'fleet camera accessories', 'fleet camera shop', 'fleet camera store',
      'fleet camera solutions', 'fleet camera products', 'fleet camera technology', 'fleet camera installation',
      'fleet camera support', 'fleet camera service', 'fleet camera professional', 'fleet camera expert', 'surfsight shop', 'surfsight store',
      'fleet camera shop online', 'fleet camera equipment store', 'fleet camera accessories shop', 'surfsight camera', 'surfsight', 'surfsight camera equipment', 'surfsight camera accessories'
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Shop Surfsight - Fleet Camera Equipment & Accessories',
    ogDescription: 'Complete fleet camera equipment and accessories shop with professional solutions. Wide selection, expert consultation, fast shipping.',
    ogType: 'website',
    ogUrl: 'https://shopsurfsight.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Shop Surfsight - Fleet Camera Equipment & Accessories',
    twitterDescription: 'Complete fleet camera equipment and accessories shop with professional solutions. Wide selection, expert consultation, fast shipping.',
    
    // Robots
    robots: 'index, follow',
    author: 'Shop Surfsight',
    publisher: 'Shop Surfsight',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Shop Surfsight - Fleet Camera Equipment & Accessories',
        description: 'Professional fleet camera equipment and accessories shop with wide selection, expert consultation, and fast shipping.',
        keywords: ['shop surfsight', 'fleet camera equipment', 'fleet camera accessories', 'fleet camera shop', 'fleet camera store']
      },
      solutions: {
        title: 'Fleet Camera Solutions - Shop Surfsight Services',
        description: 'Professional fleet camera solutions and equipment services. Expert consultation, installation, and ongoing support.',
        keywords: ['fleet camera solutions', 'fleet camera services', 'fleet camera installation', 'fleet camera support']
      },
      products: {
        title: 'Fleet Camera Products - Shop Surfsight Equipment',
        description: 'Professional fleet camera products and equipment. Wide selection, best prices, and expert support.',
        keywords: ['fleet camera products', 'fleet camera equipment', 'fleet camera accessories', 'fleet camera technology']
      },
      blog: {
        title: 'Shop Surfsight News & Insights - Fleet Camera Blog',
        description: 'Latest news, insights, and best practices for fleet camera equipment and technology, with professional tips and updates.',
        keywords: ['fleet camera news', 'fleet camera insights', 'fleet camera best practices', 'fleet camera tips']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
